import { useWorkoutCardContext } from './workout-card'
import React from 'react'
import { cn } from 'src/lib/utils'

interface WorkoutCardTitleProps {
  className?: string
}

export const WorkoutCardTitle = ({ className }: WorkoutCardTitleProps): React.ReactElement => {
  const { workout } = useWorkoutCardContext()

  return (
    <h3 className={cn('font-bebas text-4xl font-normal uppercase tracking-wide text-ivory line-clamp-2', className)}>
      {workout.title}
    </h3>
  )
}
